// Every element this script touches is placed by a Razor page, so an id that resolves to nothing is a
// template bug rather than a state a caller should handle. ById says so; TryById is for the handful of
// elements that genuinely only exist on one of the two pages.
function ById<T extends HTMLElement>(id: string): T {
    return document.getElementById(id) as T;
}

function TryById<T extends HTMLElement>(id: string): T | null {
    return document.getElementById(id) as T | null;
}

function RoomKey(): string {
    return ById<HTMLInputElement>("roomKey").value;
}

function ParticipantName(): string {
    return ById<HTMLInputElement>("participantName").value;
}

function ParticipantRole(): Role {
    return ById<HTMLInputElement>("participantRole").value as Role;
}
